<script setup>
import {ref, watchEffect} from 'vue'
import ArticleSetDetailWidget from "./components/ArticleSetDetailWidget.vue"
import {useCartStore} from "./stores/CartStore";
import {modalStore} from "./stores/ModalStore";

// emits
defineEmits(["addToCart"])

const cartStore = useCartStore();

const currentUrl = window.location.pathname
const parts = currentUrl.split("/");
const slug = parts[parts.length - 1];
let articleSet = {
    slug: slug,
};
modalStore.setArticleSet(articleSet);

const articleSetDetail = ref(null)

</script>

<template>
    <!-- Show ArticleSet -->
    <div class="row">
        <ArticleSetDetailWidget
            :key="articleSet.slug"
            :articleSet="articleSet"
        />
    </div>
</template>
